// removed by extract-text-webpack-plugin
module.exports = {"card":"CredentialsForm__card__1L99V","p":"CredentialsForm__p__8ZT2B","input":"CredentialsForm__input__WhUEr","button":"CredentialsForm__button__3kaOh","inputDiv":"CredentialsForm__inputDiv__c22W1","btnDiv":"CredentialsForm__btnDiv__2ra_4"};


//////////////////
// WEBPACK FOOTER
// ./src/CredentialsForm/CredentialsForm.css
// module id = 62
// module chunks = 0